<template>
  <div class="div-content">
    <img
      class="bg-img"
      src="@/assets/images/home-joinus-bg.png"
    >
    <h1 class="text-center h1">加入我们吧</h1>
    <div class="div-line"></div>
    <h2 class="text-center h2">点击下方下载按钮快速进入下载页面</h2>
    <div class="download text-center">
      <img
        class="img-appqr"
        src="@/assets/images/home-joinus-appqr.png"
      >
      <img
        class="img-weixinqr"
        src="@/assets/images/home-joinus-weixinqr.png"
      >
    </div>
    <p class="text-center p">下载立即获得App使用权限，更快更有效的开启工厂之旅</p>
  </div>
</template>

<script>
export default {
  name: "HomeContentJoinUs",
};
</script>

<style lang="stylus" scoped>
.div-content {
  position: relative;
}

.bg-img {
  width: 100%;
}

.h1 {
  position: absolute;
  top: 4rem;
  color: #ffffff;
  font-size: 1.9rem;
  line-height: 0.9rem;
  letter-spacing: 0rem;
  left: 50%;
  transform: translateX(-50%);
}

.div-line {
  position: absolute;
  width: 6%;
  left: 47%;
  right: 47%;
  height: 0.1rem;
  background-color: #12b7f6;
  top: 6rem;
}

.h2 {
  position: absolute;
  color: #ffffff;
  top: 8rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
}

.download {
  position: absolute;
  height: 12rem;
  width: 100%;
  top: 10rem;

  .img-appqr {
    width: 12rem;
    height: 12rem;
    padding-top: 2rem;
    padding-right: 2rem;
  }

  .img-weixinqr {
    width: 12rem;
    height: 12rem;
    padding-top: 2rem;
    padding-left: 2rem;
  }
}

.p {
  position: absolute;
  color: #cfcfcf;
  font-size: 1.5rem;
  bottom: 0.5rem;
  left: 50%;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/ContentJoinUs.vue